/**
 * Where the admin Access area lives: the `access` tab of Administration (apps/admin routes/access.routes.ts,
 * mounted by routes/administration.routes.ts). Every in-app link into the area builds on this, so moving
 * the area again is a one-line change. In libs so shared pages (a learner's Basic Information) can link
 * there too; the admin app re-exports these from pages/access/access.paths.ts.
 */
export const ACCESS_BASE_PATH = '/administration/access';

export const ACCESS_GROUPS_PATH = `${ACCESS_BASE_PATH}/groups`;
export const ACCESS_PEOPLE_PATH = `${ACCESS_BASE_PATH}/people`;
